import React,{useState, useEffect} from "react";
import axios from "axios";
import dateFormat from "dateformat";
import Card from "react-bootstrap/Card";
import moment from "moment";
import "./header-admin.scss";
import { useNavigate } from "react-router-dom";

function AdminHeader() {

  const navigate = useNavigate()

  const [data, setData] = useState([]);
  const [dataCheckinGuest, setDataCheckinGuest] = useState([])
  const [dataNewMember, setDataNewMember] = useState([]);
  const [dataExpToday, setDataExpToday] = useState([]);

  useEffect(()=>{
    getData()
    getDataCheckinGuest()
    getDataNewMember()
    getDataExpToday()
  },[dataNewMember,dataExpToday])

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/users");
    const restData = result.data.data;
    const dataActive = [];
    restData.forEach((item) => {
      if (item.active === true) {
        dataActive.push(item);
      }
    });
    setData(dataActive);
  };

  const getDataCheckinGuest = async () => {
    const result = await axios.get("https://mobile.amospa.com/checkin");
    setDataCheckinGuest(result.data.data);
  };

  const getDataNewMember = async () => {
    const result = await axios.get("https://mobile.amospa.com/newmember/");
    setDataNewMember(result.data.data);
    autoDelete(result.data.data)
  };

  //atomatis delete new member
  const autoDelete = (data) => {
    const d = new Date();
    data &&
      data.forEach(async (item) => {
        if (item.out !== null) {
          if (
            dateFormat(new Date(item.out), "d-mm-yyyy") !==
            dateFormat(d, "d-mm-yyyy")
          ) {
            await axios.delete(
              `https://mobile.amospa.com/newmember/${item.id}`
            );
          }
        }
      });
  };

  const getDataExpToday = async () => {
    const result = await axios.get("https://mobile.amospa.com/users");
    const restData = result.data.data;
    delExpired(result.data.data);
    const dataActive = [];
    restData.forEach((item) => {
      if (item.active === true && moment(item?.expired).parseZone().format('DD/MM/YYYY') == 
      moment(new Date()).parseZone().format('DD/MM/YYYY')) {
        dataActive.push(item);
      }
    });
    setDataExpToday(dataActive);
  };

  const delExpired = (dataUser) => {
    let today = new Date();
    dataUser.forEach(async (item) => {
      let exp = new Date(item.expired);
      if (today.getFullYear() > exp.getFullYear()) {
        return await axios.put(`https://mobile.amospa.com/users/${item.id}`, {
          active: false,
        });
      }

      if (exp.getFullYear() === today.getFullYear()) {
        if (today.getMonth() + 1 > exp.getMonth() + 1) {
          return await axios.put(`https://mobile.amospa.com/users/${item.id}`, {
            active: false,
          });
        } else if (today.getMonth() + 1 === exp.getMonth() + 1) {
          if (today.getDate() > exp.getDate()) {
           return await axios.put(
              `https://mobile.amospa.com/users/${item.id}`,
              {
                active: false,
              }
            );
          }
        }
      }
    });
  };


  return (
    <div className="admin-header-component">
      {/* Header-admin-dasboard */}
      <div className="container-fluid">
        <div className="row">
          <span className="d-flex flex-column">
            <h4>Welcome To</h4>
            <h1>Membership Manager</h1>
          </span>
          <div className="col-lg-3 col-md-6 mt-2 mb-2">
            <Card id="card-monthly" onClick={()=>navigate('/homepage/members/')}>
              <Card.Body id="card-body-admin">
                Active Member
                <span>{data?.length}</span>
              </Card.Body>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 mt-2 mb-2">
            <Card id="card-annual" onClick={()=>navigate('/homepage/members/chekin/')}>
              <Card.Body id="card-body-admin">
                Checkin Guest
                <span>{dataCheckinGuest?.length}</span>
              </Card.Body>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 mt-2 mb-2">
            <Card id="card-task" onClick={()=>navigate('/homepage/members/exp/')}>
              <Card.Body id="card-body-admin">
                Expired Today
                <span>{dataExpToday?.length}</span>
              </Card.Body>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 mt-2 mb-2">
            <Card id="card-panding" onClick={()=>navigate('/homepage/members/new-member/')}>
              <Card.Body id="card-body-admin">
                New Member
                <span>{dataNewMember?.length}</span>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminHeader;
